import React from "react";
import { Link } from "react-router-dom";
import PublicNavbar from "../components/layout/PublicNavbar";
import Footer from "../components/layout/Footer";
import { ShieldCheck, LineChart, Sparkles, DoorOpen, FileCheck2, MessageSquare } from "lucide-react";
import Seo from "../components/Seo";

export default function ForStartups() {
  return (
    <div className="min-h-screen bg-transparent text-ink">
      <Seo
        title="For Startups | Raise Capital with VenturaZ"
        description="Get discovered by qualified investors. VenturaZ pairs verified founders with the right investors through AI-scored matches, structured deal rooms and secure document vaults."
        path="/for-startups"
      />
      <PublicNavbar />
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="overline mb-4">FOR FOUNDERS</div>
        <h1 className="font-display text-4xl lg:text-6xl text-ink leading-tight max-w-4xl">Raise from the right kind of capital.</h1>
        <p className="text-ink-soft mt-6 max-w-2xl text-lg leading-relaxed">
          VenturaZ puts your funding profile in front of institutional investors, family offices, funds and lenders — matched to your sector, stage and geography.
        </p>
        <div className="mt-8 flex gap-3">
          <Link to="/startup/apply" className="px-6 py-3 bg-gold text-ink-bg font-heading font-semibold hover:bg-gold-hover transition-colors" data-testid="startup-apply-cta">Apply for Funding</Link>
          <Link to="/how-it-works" className="px-6 py-3 border border-white/20 text-ink font-heading hover:border-gold hover:text-gold transition-colors">How It Works</Link>
        </div>
      </section>

      <section className="border-y border-white/10 bg-white/70 backdrop-blur/40 py-20">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: FileCheck2, t: "Structured funding profile", b: "Founder info, cap table, financials, use of funds — captured cleanly." },
            { icon: ShieldCheck, t: "KYC + verification", b: "Investors see verified data. No noise, no red flags." },
            { icon: Sparkles, t: "Curated match", b: "Rule-based + AI reasoning across sector, stage, ticket, geography." },
            { icon: MessageSquare, t: "Controlled query flow", b: "Predefined questions. Admin-moderated responses." },
            { icon: DoorOpen, t: "Deal rooms", b: "Timeline, documents, term sheet, due diligence — one canvas." },
            { icon: LineChart, t: "Pipeline metrics", b: "Live view of investor interest, queries and deal room stage." },
          ].map((f, i) => (
            <div key={i} className="border border-white/10 bg-white/70 backdrop-blur p-6">
              <f.icon className="text-gold mb-3" size={20} />
              <div className="font-heading text-ink text-lg mb-1">{f.t}</div>
              <div className="text-ink-muted text-sm leading-relaxed">{f.b}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto px-6 lg:px-10 py-20">
        <div className="overline mb-3">SIX-STEP JOURNEY</div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {["Signup", "Profile & KYC", "Funding Profile", "Document Vault", "Curated Matches", "Deal Room"].map((s, i) => (
            <div key={s} className="border border-white/10 bg-white/70 backdrop-blur p-6">
              <div className="font-mono text-gold text-xs tracking-widest">{String(i + 1).padStart(2, "0")}</div>
              <div className="font-heading text-ink text-lg mt-3">{s}</div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
